import { PeopleComponent } from './../Search-list-UI/people/people.component';
import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { BusinessUserComponent } from '../Search-list-UI/business-user/business-user.component';
import { PostComponent } from '../Search-list-UI/post/post.component';
import { SearchjobComponent } from '../Search-list-UI/searchjob/searchjob.component';
import { SearchcandidateComponent } from '../Search-list-UI/searchcandidate/searchcandidate.component';
import { SearchMenuComponent } from '../Search-list-UI/search-menu/search-menu.component';
import { AllUserListComponent } from '../Search-list-UI/all-user-list/all-user-list.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-search-list',
  standalone: true,
  imports: [CommonModule, RouterModule, BusinessUserComponent, PostComponent, SearchjobComponent, SearchcandidateComponent, SearchMenuComponent, AllUserListComponent, PeopleComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.scss']
})
export class SearchListComponent implements OnInit {

  name = 'Angular';

   @ViewChild('filterData') filterdataRef: ElementRef;

   @Output() filterScarch = new EventEmitter<string>();


  searchmenustick: boolean = false;
  menuData;
  menuData1;
  data
  searchName
  navbarSearchData
  searchText


  constructor(
    // private publicpage: PeopleComponent
    private router: Router ,
    private route: ActivatedRoute,
    ) { }

  ngOnInit() {
   this.queryParamsData();
  }


  handleScroll(){
    const windowScroll = window.pageYOffset;
    if(windowScroll >= 362){
      this.searchmenustick = true;
    } else {
      this.searchmenustick = false;
    }
  }

  queryParamsData(){
    this.route.queryParams.subscribe(data =>{
       this.menuData1 = data
      this.navbarSearchData = this.menuData1;
      this.searchText = data.searchData;
      this.menuData = data.data;
      // Switching All / People / Business (or a new search) only changes the
      // query params, so this component is reused and ngOnInit does not run
      // again. Reset the window scroll here so every new listing starts at the top.
      window.scrollTo({ top: 0 });
     })
  }

  // tslint:disable-next-line: member-ordering



  // ngAfterViewInit() {
  //   console.log('Hello ', this.name);
  // };
  navigation(menuSelected){
    // Only navigate; menuData is set by the queryParams subscription once the
    // URL has changed. Setting it here too created the tab component early, so
    // it subscribed with the OLD params and then again with the new ones,
    // firing its first-page request twice.
    let datas:any={}
    datas.data=menuSelected;
    datas.searchData=this.searchText;
    this.router.navigate(['Search-list'],{queryParams : datas});
  }

  // businessUserData(data){
  //   this.data=

  // }

  onkeypressEvent(event){

  }

  filter(){
    const filterInputData = this.filterdataRef.nativeElement.value;
    this.filterScarch.emit(filterInputData);
  }

}
